// extracted by mini-css-extract-plugin
export default {"container":"slider_container__v-H-R","animated":"slider_animated__fq4PH"};